import { CAMPAIGN_ENUM_TYPES } from '../../shared/constants'

export const roundTo2 = value => (value ? value.toFixed(2) : 0)

const D2DandH2HonlyTableFields = [
  'totalMissions',
  'distributionCost',
  'travelCost',
  'permitCost',
  'bonusBudget',
  'outfitCost',
]
const DMonlyTableFields = ['postingCost', 'dataCost', 'freightCost']

const generateTotalRowData = (totalData, type) => {
  const keys = [
    {
      label: 'Total',
    },
    {
      key: 'totalFlyers',
      value: totalData.totalFlyers,
    },
    {
      key: 'totalMissions',
      value: totalData.totalMissions,
    },
    {
      key: 'distributionCost',
      value: totalData.distributionCost,
    },
    {
      key: 'travelCost',
      value: totalData.travelCost,
    },
    {
      key: 'permitCost',
      value: totalData.permitCost,
    },
    {
      key: 'printingCost',
      value: totalData.printingCost,
    },
    {
      key: 'bonusBudget',
      value: totalData.bonusBudget,
    },
    {
      key: 'postingCost',
      value: totalData.postingCost,
    },
    {
      key: 'dataCost',
      value: totalData.dataCost,
    },
    {
      key: 'outfitCost',
      value: totalData.outfitCost,
    },
    {
      key: 'freightCost',
      value: totalData.freightCost,
    },
    {
      key: 'totalCost',
      value: roundTo2(totalData.totalCost),
    },
  ]

  if (
    type == CAMPAIGN_ENUM_TYPES.HANDTOHAND ||
    type == CAMPAIGN_ENUM_TYPES.LETTERBOX ||
    type == CAMPAIGN_ENUM_TYPES.UNCERTAIN
  ) {
    return keys.filter(key => key.label || !DMonlyTableFields.includes(key.key))
  }
  if (type == CAMPAIGN_ENUM_TYPES.DIRECTMAIL) {
    return keys.filter(
      key => key.label || !D2DandH2HonlyTableFields.includes(key.key),
    )
  }
}

const notCalculatedInColumnTotal = [
  'id',
  'key',
  'name',
  'tax',
  'state',
  'postalCode',
]

const filterEntriesDependingOnCampaignType = (entries, type) => {
  if (
    type == CAMPAIGN_ENUM_TYPES.HANDTOHAND ||
    type == CAMPAIGN_ENUM_TYPES.LETTERBOX ||
    type == CAMPAIGN_ENUM_TYPES.UNCERTAIN
  ) {
    return entries.filter(entry => !DMonlyTableFields.includes(entry[0]))
  }
  if (type == CAMPAIGN_ENUM_TYPES.DIRECTMAIL) {
    return entries.filter(entry => !D2DandH2HonlyTableFields.includes(entry[0]))
  }
}

export const generateTotalRow = (data, type) => {
  const calculateColumnTotal = data.reduce((acc, item) => {
    const entries = Object.entries(item)
    const filteredEntriesByType = filterEntriesDependingOnCampaignType(
      entries,
      type,
    )
    filteredEntriesByType.forEach(entry => {
      const key = entry[0]
      const value = entry[1]
      if (notCalculatedInColumnTotal.includes(key)) return acc
      if (acc[key]) {
        acc[key] += value
        return acc
      } else {
        acc[key] = value
        return acc
      }
    })
    return acc
  }, {})
  const totalRow = generateTotalRowData(calculateColumnTotal, type)
  return totalRow
}

export const filterTableKeysByCampaignType = (type, keys) => {
  if (
    type == CAMPAIGN_ENUM_TYPES.HANDTOHAND ||
    type == CAMPAIGN_ENUM_TYPES.LETTERBOX ||
    type == CAMPAIGN_ENUM_TYPES.UNCERTAIN
  ) {
    return keys.filter(key => !DMonlyTableFields.includes(key.key))
  }
  if (type == CAMPAIGN_ENUM_TYPES.DIRECTMAIL) {
    return keys.filter(key => !D2DandH2HonlyTableFields.includes(key.key))
  }
}

export const calculateTotalCostDependingOfType = (data, type) => {
  const calculatedInTotalValues =
    type == CAMPAIGN_ENUM_TYPES.DIRECTMAIL
      ? ['printingCost', 'postingCost', 'dataCost', 'freightCost', 'taxAmount']
      : [
          'bonusBudget',
          'distributionCost',
          'permitCost',
          'printingCost',
          'travelCost',
          'outfitCost',
          'taxAmount',
        ]
  const cityMetricsWithTotal = data.map(item => {
    const entries = Object.entries(item)
    let total = 0
    entries.forEach(entry =>
      calculatedInTotalValues.includes(entry[0]) ? (total += entry[1]) : null,
    )

    const result = { ...item }

    result.totalCost = total
    result.subtotal = total - result.taxAmount

    return result
  })
  return cityMetricsWithTotal
}

export const isValueValid = value => {
  if (!value) {
    return true
  }
  return !/^\s*$/.test(value) && !isNaN(value)
}

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}
const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export const insertBeforeTotalCost = (headers, objectsToInsert) => {
  // Find the index of the object with key "totalCost"
  const totalCostIndex = headers.findIndex(item => item.key === 'totalCost')

  if (totalCostIndex === -1) {
    console.error('totalCost object not found in the array.')
    return headers
  }

  // Insert the objects at the found index
  headers.splice(totalCostIndex, 0, ...objectsToInsert)

  return headers
}
